"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SampleEventFactoryInterface = _interopRequireDefault(require("crm_ui/utils/sampleData/SampleEventFactoryInterface"));

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _TimelineConstants = require("crm_universal/timeline/TimelineConstants");

var makeMeetingSampleTimelineEvent = (0, _SampleEventFactoryInterface.default)({
  requiredData: {
    eventType: _TimelineConstants.EVENT_ENGAGEMENT,
    itemType: _EngagementTypes.MEETING
  },
  eventDefaults: {
    title: '',
    body: '',
    endTime: Date.now(),
    startTime: Date.now(),
    inviteeEmails: []
  },
  build: function build(meetingData) {
    var title = meetingData.title,
        body = meetingData.body,
        endTime = meetingData.endTime,
        startTime = meetingData.startTime,
        inviteeEmails = meetingData.inviteeEmails;
    var eventData = {
      associateCurrentContact: true,
      inviteeEmails: inviteeEmails,
      metadata: {
        title: title,
        body: body,
        endTime: endTime,
        startTime: startTime
      }
    };
    return eventData;
  }
});
var _default = makeMeetingSampleTimelineEvent;
exports.default = _default;
module.exports = exports.default;